/*
 * @Description: 出行信息
 */
<template minapp='mpx' xlang='wxml'>
  <view>
    <view class="change-ticket-tip" wx:if="{{ showChangeTips }}">
      改签票需支付全价票款，原票票款扣除手续费后原路退回。
    </view>
    <!-- 之前区分小程序和h5 适配底部状态栏 后品类统一样式 固定高度因此下掉-->
    <!-- wx:style="padding-bottom: {{footerPaddingBottom}}" -->
    <view class="bottom-action">
      <view class="money-container">
        <view class="order-money" wx:for="{{payInfo}}">
          <view class="order-money-type" wx:if="{{studentLength > 0}}">约</view>
          <view class="order-money-type" wx:style="{{item.pay_style}}">￥</view>
          <view class="order-money-num" wx:style="{{item.pay_style}}">
            {{ item.pay_price }}</view
          >
        </view>
        <view class="discount-area" wx:if="{{isShowCrossedPrice}}">
          <!-- 券透传信息 -->
          <view wx:if="{{discountInfo.discount_desc}}" class="discount-desc">{{discountInfo.discount_desc}}</view>
          <!-- 官方原价 -->
          <crossed-price
            class="original-price"
            price="{{Number(discountInfo.coupon_after_price)}}"
          />
        </view>
      </view>
      <view class="order-action-bottom">
        <view wx:if="{{showDealDetail}}" class="order-action-bottom-1" bindtap="switchDealDetail">
          <text>明细</text>
          <view class="down-arrow" wx:class="{{!showDealAlert  && 'rotate'}}"></view>
        </view>
        <block wx:if="{{isFromScramble & payType}}">
        <!-- 抢票的填单页，因为加速包的存在，变为两个按钮，payType1填单页-->
          <view
            wx:for="{{scrambleButton}}" 
            wx:for-item="item" 
            wx:class="{{ {'order-action-bottom-2':true, disabled:!canPay} }}"
            wx:style="{{item.extra.containerStyle}}"
            bindtap="makeScramblePay(item)"
          >
            <view wx:style="{{item.extra.textStyle}}">{{ item.extra.buttonText }}</view>
          </view>
        </block>
        <block wx:else>
          <!-- 其他 保持原逻辑-->
          <view
            class="{{ {'order-action-bottom-2':true,disabled:!canPay} }}"
            bindtap="makePay"
          >
            <view>{{ buttonCopyWritting }}</view>
            <view wx:if="{{buttonDesText}}" class="button-coupon-desc">{{buttonDesText}}</view>
          </view>
        </block>
      </view>
    </view>
  </view>
</template>

<style lang="stylus" scoped>
  .change-ticket-tip
    color $train-color-theme-blue
    font-size 12px
    font-weight 400
    background linear-gradient(-63deg, #fefefe 0%, #edf4ff 100%)
    padding 8px 12px
  .bottom-action
    width 100vw
    height 98px
    font-family PingFangSC
    padding 11px 14px 39px 16px !important
    background-color #ffffff
    box-sizing border-box
    display flex
    justify-content space-between
    .money-container
      margin-top 4px
    .discount-area
      display flex
      margin-top 4px
      align-items center
      .discount-desc
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #FF6400
        margin-right 4px
      .original-price
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #999
    .order-money
      line-height 32px
      display flex
      align-items flex-end
      color #FF6400
      .order-money-type
        font-family PingFangSC-Semibold
        font-size 16px
        line-height 16px
        transform translateY(-4px)
      .order-money-num
        font-family Barlow Semi Condensed
        font-size 32px
        font-weight 400
        &-personal
          color #FF7D41
      .order-money-warn
        margin-left 6px
        font-size 12px
        color #999
        font-family PingFangSC-Regular
    .order-action-bottom
      display flex
      justify-content space-between
      .order-action-bottom-1
        display flex
        height 48px
        line-height 48px
        text-align center
        color #666
        font-weight normal
        font-size 13px
        justify-content center
        align-items center
        margin-right 14px
        min-width 34px
        .down-arrow
          background url('https://dpubstatic.udache.com/static/dpubimg/ZYtJNbT6WhCj_kokty2zz.png')
          background-size cover
          background-repeat no-repeat
          width 6px
          height 3px
          margin-left 4px
          &.rotate
            transform rotate(180deg)
      .button-coupon-desc
        position absolute
        top -8px
        right -1.5px
        padding 2px 4px
        background #FF4343
        border 1.5px solid #fff
        font-family PingFangSC-Medium
        font-size 10px
        font-weight normal
        line-height 12px
        color #fff
        border-radius 10px 10px 0 10px
        position absolute
      .order-action-bottom-2
        position relative
        width 140px
        height 50px
        line-height 48px
        text-align center
        border-radius 8px
        background #ff6400
        color #ffffff
        font-family PingFangSC-Medium
        font-size 16px
        &.disabled
          opacity 0.3
        
</style>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'
  import { getStorage } from '@/utils/storage'
  import { STORAGE_DETAIL_SEARCH_QUERY } from '@/utils/train-storage'
  import { cloneDeep } from 'lodash'
  createComponent({
    props: {
      canPay: {
        type: Boolean,
        value: true,
      },
      showChangeTips: {
        type: Boolean,
        value: false,
      },
      showDealAlert: {
        type: Boolean,
        value: false,
      },
      payType: {
        //使用场景 默认0为待支付 1改动后提交订单页
        type: Number,
        value: 0
      },
      totalFeeInfo: {
        type: Array,
        value: ()=>[]
      },
      isFromScramble: Boolean,
      studentLength: Number,
      isExemption: Number
    },
    computed: {
      ...store.mapState({
        couponInfo: 'order.coupon_info', // 费用明细
        feeInfo: 'order.fee_info', // 费用明细
        packageInfo: 'train.packageInfo', //返回的加速包模块信息
        selectPackageItem: 'train.selectPackageItem',//选中的加速包信息
      }),
      payInfo() {
        // 记录: totalFeeInfo 为前端从列表页拿的数据, 给提交订单页使用的
        // feeInfo 是成单及之后节点服务端下发
        // 疑惑: 数据结构为啥不一样啊
        return this.payType ? this.totalFeeInfo : [this.handleFeeInfo(this.feeInfo)]
      },
      showDealDetail(){
        let flag = true
        if (this.payType == 1 && !this.canPay) flag = false
        return flag
      },
      discountInfo() {
        // 为什么会是这样, template 之前经历了什么
        return this.payInfo?.[0]
      },
      // 是否展示划线价
      isShowCrossedPrice() {
        return Number(this.discountInfo?.pay_price) !== Number(this.discountInfo?.coupon_after_price)
      },
      buttonCopyWritting() {
        return this.payType === 0 ? '立即支付' : '提交订单'
      },
      // 气泡文案
      buttonDesText() {
        return this.payType === 1
          ? getStorage(STORAGE_DETAIL_SEARCH_QUERY)?.button_coupon_desc || ''
          : this.couponInfo.button_coupon_desc
      },
      detailIconUrl() {
        return this.showDealAlert ? '' : ''
      },
      scrambleButton(){
        const isRecommend = !!this.selectPackageItem?.recommend // true 当前是默认推荐速度的状态
        const isNoExtralPackage = this.selectPackageItem?.status == 0  // true 当前是不加速的状态 
        const flag = isRecommend || isNoExtralPackage //当前是否是 默认推荐速度||不加速
        let currentPackage = this.selectPackageItem
        let noPackage = this.packageInfo?.packages?.[0]
        noPackage = {
          ...noPackage,
          extra:{
            containerStyle:{
              width: isNoExtralPackage? '188px':'76px',
              border: '1px solid #FF5900',
              background: isNoExtralPackage? '#FF6400':'#FFFFFF',
              marginRight: isNoExtralPackage? '':'6px',
              fontSize: '14px',
              boxSizing: 'border-box'
            },
            textStyle:{
              color:  isNoExtralPackage? '#FFFFFF':'#FF5900',
            },
            buttonText:'普通抢'
          }
        }
        currentPackage = {
          ...currentPackage,
          extra:{
            containerStyle:{
              width: isRecommend? '106px':'188px',
              background: '#FF6400',
              fontSize: '14px',
            },
            textStyle:{
              color: '#FFFFFF'
            },
            buttonText:`+¥${currentPackage.show_price} ${currentPackage.status_name}抢`
          }
        }
        let obj 
        if (isRecommend) obj=[noPackage, currentPackage]
        else if (isNoExtralPackage) obj = [noPackage]
        else obj=[currentPackage]
        return obj
      },
    },
    methods: {
      ...store.mapMutations({
        setSelectPackage:'train.setSelectPackage',
        setScrambleBtnTrackType: 'makeOrder.setScrambleBtnTrackType'
      }),
      switchDealDetail() {
        this.$trigger('click')
      },
      makePay() {
        this.canPay && this.$trigger('pay')
      },
      makeScramblePay(item){
        const _item = cloneDeep(item)
        if(_item.extra?.buttonText !== '普通抢'){
          this.setScrambleBtnTrackType('speedup')
        }
        else {
          this.setScrambleBtnTrackType('normal')
        }
        delete _item.extra
        this.setSelectPackage(_item)
        this.canPay && this.$trigger('scramblePay',{
          package:_item
        })
      },
      // 数据格式转换, 为兼容老 template 逻辑
      handleFeeInfo(fee = {}) {
        return {
          ...fee,
          pay_price: getFinalPrice(fee.coupon_after_price || fee.total_price),
          coupon_after_price: getFinalPrice(fee.total_price),
        }
      }
    },
  })
</script>

<script name='json'>
  module.exports = {
    usingComponents: {
      'crossed-price': '@/components/crossed-price',
      'es-descriptions': '@didi/es-mpx-ui/lib/descriptions',
      'es-card-wrap1': '@didi/es-mpx-ui/lib/card/card-wrap1',
      'order-inline-info': '@/components/order-inline-info',
    },
  }
</script>